import React from 'react';
import PropTypes from 'prop-types';
import { IconClear } from '@piggybank/core';
import styles from './styles.css';

const RemoveButton = ({ inputRef, clearSelectionAriaLabel, reset }) => {
  return (
    <button
      className={styles.removeButton}
      type="button"
      tabIndex={-1}
      aria-label={clearSelectionAriaLabel}
      onClick={() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
        reset();
      }}
    >
      <IconClear />
    </button>
  );
};

RemoveButton.propTypes = {
  inputRef: PropTypes.object.isRequired,
  clearSelectionAriaLabel: PropTypes.string.isRequired,
  reset: PropTypes.func.isRequired,
};

export default RemoveButton;
